import { render, staticRenderFns } from "./byProductSSF.vue?vue&type=template&id=7913a54f&"
import script from "./byProductSSF.vue?vue&type=script&lang=ts&"
export * from "./byProductSSF.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports